import React from 'react'
import PropTypes from 'prop-types'
import {
  IconChevronDown, IconChevronRight
} from '@yoti/ui-kit-components-react/icons';

import './AccordionItem.scss'

const AccordionItem = ({
  title,
  content,
  onToggle,
  isOpened
}) => (
  <div className="accordion-item">
    <div role="button" className="accordion-item__toggle" onClick={onToggle}>
      <h6 className="accordion-item__toggle__header">
        { title }
      </h6>
      <span className="accordion-item__toggle__chevron-icon">
        {isOpened ? <IconChevronDown /> : <IconChevronRight />}
      </span>
    </div>
    {
      isOpened
      && (
        <div className="accordion-item__content">
          { content }
        </div>
      )
    }
  </div>
)

AccordionItem.propTypes = {
  title: PropTypes.objectOf(PropTypes.any).isRequired,
  content: PropTypes.node.isRequired,
  onToggle: PropTypes.func.isRequired,
  isOpened: PropTypes.bool.isRequired,
}

export default AccordionItem
